export default "__VITE_ASSET__7927e413__"